import { FjdModal, FjdSpinner } from 'fjd-react-components';
import { useKommunikationPdf } from '../../../../hooks/useKommunikationPdf';
import { ErrorComponentBehoerdenServer } from '../../../shared/Error/ErrorComponent';
import { FjdModalProps } from 'fjd-react-components/build/components/Modal/Modal';
import './KommunikationPdfDrucken.css';
import { useEffect } from 'react';

interface KommunikationPdfDruckenModalProps {
  readonly onClose: () => void;
  readonly caseId: string;
  readonly isOpen: boolean;
}

export function KommunikationPdfDrucken({
  onClose,
  caseId,
  isOpen
}: KommunikationPdfDruckenModalProps) {
  const { pdf, isValidating, error, mutate } = useKommunikationPdf({ caseId });

  useEffect(() => {
    if (isOpen) {
      mutate();
    }
  }, [isOpen, mutate]);

  const payload = pdf ?? '';

  const modalPropertiesBase: Partial<FjdModalProps> = {
    appElement: document.querySelector('.fjd-base-layout') as HTMLElement,
    closeOnBackdropClick: false,
    id: 'kommunikationpdf-modal',
    onClose: onClose,
    open: isOpen
  };

  const modalPropertiesError: Partial<FjdModalProps> = {
    heading: 'PDF drucken',
    secondaryButtonDisabled: true,
    primaryButtonLabel: 'Schließen',
    onPrimaryButtonClick: () => onClose()
  };

  const modalPropertiesNoError: Partial<FjdModalProps> = {
    heading: '',
    primaryButtonDisabled: true,
    secondaryButtonDisabled: true,
    testId: 'kommunikationpdf-modal',
    width: 'fullscreen'
  };

  const modalProperties: FjdModalProps = error
    ? ({ ...modalPropertiesBase, ...modalPropertiesError } as FjdModalProps)
    : ({ ...modalPropertiesBase, ...modalPropertiesNoError } as FjdModalProps);

  return (
    <FjdModal {...modalProperties}>
      {error ? (
        <ErrorComponentBehoerdenServer errorCode={error?.traceId} />
      ) : isValidating ? (
        <div style={{ justifyContent: 'center', display: 'flex' }}>
          <FjdSpinner size="l" />
        </div>
      ) : (
        <object
          aria-label="kommunikationpdf-PDF"
          data={`data:application/pdf;base64, ${encodeURI(payload)}`}
          type="application/pdf"
          width="100%"
          height="100%"
        />
      )}
    </FjdModal>
  );
}

export default KommunikationPdfDrucken;
